import _ from 'lodash'

export default ({
  path,
  arrayHelpers: { remove },
  values: { [path]: items },
}) => ({ id }) => remove(_.findIndex(items, { id }))
